export default "__VITE_ASSET__Cy9gk6E0__"